import './components';
import './stores';
import '../shared';
import { debounce } from 'lodash';
import {
  makeCarousel,
  makeUnmountedCarousel,
} from '../../auto/utils/carousel/splide';
import { initSectionWhenItIsVisible } from '../../auto/utils/initSectionWhenItIsVisible';
import hookConversion from '../../auto/utils/hookConversion';

window.makeCarousel = makeCarousel;
window.makeUnmountedCarousel = makeUnmountedCarousel;
window.debounce = debounce;

window.hookConversion = hookConversion;

window.helpers = {
  ...helpers,
  initSectionWhenItIsVisible,
};
